import React from 'react';
import {QueryBuilder} from 'material-ui-icons';

import tlplaceholder from './img/placeholder.png';

function PauseBlock({t}) {
	return (
		<div
			className='excerciseBlockWrapper'
			style={{paddingTop: 20, paddingBottom: 10}}
		>
			<QueryBuilder />
			<p className='excercisePause'>{t('workout:proposedPause')}</p>
		</div>
	);
}

function ExcerciseBlock({reps, duration, image, name, t, onPress}) {
	const isPause = name === 'Pause';
	if (isPause) return <PauseBlock t={t} />;

	return (
		<div
			onClick={() => {
				onPress();
			}}
			className='excerciseBlockWrapper clickable'
		>
			{reps && (
				<div className='workoutRepInfo roundedDetailWrapper inactive'>
					<span className='amount'>{reps}</span>
					<span className='unit'>{t('workout:reps')}</span>
				</div>
			)}
			{duration && (
				<div className='workoutRepInfo roundedDetailWrapper inactive'>
					<span className='amount'>{duration}</span>
					<span className='unit'>{t('workout:secs')}</span>
				</div>
			)}
			<div className='excerciseNameWrapper'>
				<p className='excerciseName'>{name}</p>
			</div>
			<div className='roundedDetailWrapper nextWorkoutImage'>
				<img
					src={image ? image : tlplaceholder}
					className='roundedDetailWrapper'
				></img>
			</div>
		</div>
	);
}
export default ExcerciseBlock;



// WEBPACK FOOTER //
// ./src/workoutPreview/ExcerciseBlock.js